// extracted by mini-css-extract-plugin
export default {"root":"PlasmicDashboardInProgressStatusCard_root__41Vhl","text":"PlasmicDashboardInProgressStatusCard_text__2hwxU"};